import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { MensajeService } from '../services/mensaje.service';
import * as moment from 'moment';
import { Constantes } from '../constantes/constantes';
import { MatDialog } from '@angular/material/dialog';
import { FacLogErrorService } from '../services/candidato/fac-log-error.service';
import Swal from 'sweetalert2';
import { element } from 'protractor';

@Injectable()
export class Interceptor implements HttpInterceptor {
    constructor(
        private router: Router,
        private mensajeService: MensajeService,
        private constantes: Constantes,
        private dialogRef: MatDialog,
        private facLogErrorService: FacLogErrorService
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        const headers: any = {};
        let contieneHeader = false;
        const fechaActual = moment(new Date()).format('YYYY-MM-DD HH:mm');

        if (sessionStorage.getItem('token')) {
            headers.Authorization = 'Bearer ' + sessionStorage.getItem('token');
            contieneHeader = true;

            if (moment(fechaActual).diff(sessionStorage.ultimoUso, 'minutes') >= this.constantes.TIEMPO_EXPIRACION_MINUTOS) {
                if (this.router.url == "/dashboard/pruebasOnline/prueba" && localStorage.manejoErrores == 'false') {
                    localStorage.manejoErrores = 'true';
                    this.saveLogErrorPrueba();                    
                }
                // this.router.navigate(['/login']);
                Swal.fire({
                    icon: 'warning',
                    title: 'Alerta',
                    text: 'Su tiempo de sesión a terminado',
                    confirmButtonColor: '#3ba936',
                    cancelButtonColor:'#3ba936',
                    // onAfterClose: () =>this.router.navigate(['/login'])
                    
                  }).then(element =>{

                      this.router.navigate(['/IniciarSesion']);
                  }
                  );
                // this.mensajeService.visualizarWarning('Su tiempo de sesión a terminado', 'Alerta').then(data=>{
                //     this.router.navigate(['/login']);
                // });
                this.dialogRef.closeAll();
            }else{
                
            }
            sessionStorage.ultimoUso = moment(new Date()).format('YYYY-MM-DD HH:mm');
        }

        let authReq: HttpRequest<any>;
        if (contieneHeader) {
            authReq = req.clone({
                setHeaders: headers
            });
        } else {
            authReq = req;
        }

        return next.handle(authReq);
    }

    saveLogErrorPrueba() {
        let obj = {
            usuPersona: localStorage.xzs,
            pruebaCandidato: localStorage.prub,
            fecha: moment(new Date()).format('YYYY-MM-DD'),
            tipoError: 'Tiempo de sesión a terminado'
        };

        console.log('Componente factLogError - operacion saveLogErrorPrueba: [data enviada] ', obj);
        this.facLogErrorService.saveFacLogError(obj)
            .subscribe(data => {
                console.log('Componente  factLogError - operacion saveLogErrorPrueba: [data recibida] ', data);
            },
                error => {
                    console.log('Componente  factLogError - operacion saveLogErrorPrueba: [error recibido] ', error);
                });
    }

}